import ScrollMagic from 'scrollmagic';
import 'imports-loader?define=>false!scrollmagic/scrollmagic/uncompressed/plugins/animation.gsap';
import 'imports-loader?define=>false!scrollmagic/scrollmagic/uncompressed/plugins/debug.addIndicators';

export default class ScrollSectionsFixed {
	constructor(opts) {
		// DOM
		this._dom = {};
		this._dom.summary = {};
		this._dom.summary.parent = opts.dom.summary.parent;
		this._dom.summary.items = opts.dom.summary.items;
		this._dom.sections = {};
		this._dom.sections.parent = opts.dom.sections.parent;
		this._dom.sections.items = opts.dom.sections.items;
		this._params = {};
		if (opts.params) {
			this._params = {
				hasDuration: (opts.params.hasDuration) ? opts.params.hasDuration : false,
				hasOffset: (opts.params.hasOffset) ? opts.params.hasOffset : 0
			};
		}

		this._heightSummary = 0;
		for(let i = 0, j = this._dom.summary.items.length; i < j; i++) {
			let element = this._dom.summary.items[i];
			this._heightSummary += element.offsetHeight;

			let margin = parseInt(window.getComputedStyle(element).getPropertyValue('margin-top').split('px')[0]) + parseInt(window.getComputedStyle(element).getPropertyValue('margin-bottom').split('px')[0]);
			this._heightSummary += margin;
		}

		this._bind();
	}

	_bind() {
		// init controller
		this.controller = new ScrollMagic.Controller();
		this.controller.scrollTo(function (newpos) {
			var w = window,
				d = document,
				e = d.documentElement,
				g = d.getElementsByTagName('body')[0],
				x = w.innerWidth || e.clientWidth || g.clientWidth,
				y = w.innerHeight|| e.clientHeight|| g.clientHeight;
			var safetyMarge = 5;
			
			TweenMax.to(window, 0.5, {scrollTo: {y: newpos - y / 2 + safetyMarge}});
		});

		// PIN - SUMMARY (fixed element)
		// console.log( this._heightSummary );
		// let durationHeight = ( this._params.hasDuration ) ? this._dom.sections.parent.offsetHeight - (this._dom.summary.parent.offsetHeight / 2) : 0;
		let durationHeight = ( this._params.hasDuration ) ? this._dom.sections.parent.offsetHeight - ( this._heightSummary + 200 ) : 0;
		this.scene = new ScrollMagic.Scene({triggerElement: this._dom.summary.parent, duration: durationHeight, offset: this._params.hasOffset })
			.setPin(this._dom.summary.parent)
			.addTo(this.controller)
			// .addIndicators();

		// SECTIONS (Class Manager)
		for (let i = 0; i < this._dom.sections.items.length; i++) {
			let section = this._dom.sections.items[i];
			let summary = this._dom.summary.items[i];
			let durationSection = section.offsetHeight;
			new ScrollMagic.Scene({triggerElement: section, duration: durationSection})
				.setClassToggle(summary, "active") // add class toggle
				.addTo(this.controller);

			summary.addEventListener('click', ()=>{
				this.controller.scrollTo(section);
			});
		}
	}

}



// WEBPACK FOOTER //
// ./src/js/helpers/scroll-sections-fixed.js